module.exports = __webpack_public_path__ + "img/gold-sertificate.58125e03.svg";